import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useMessageBus } from "@jti/fe-message-bus";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/Icon";
import { LinkBehaviour } from "../../../components/LinkBehaviour";
import ArrowRight from "../../../icons/arrow-right-button.svg";
import { ListStyles } from "../types";
import styles from "./ListItem.module.scss";
export const ListItem = ({ style, item, listClickEvent, enableCookieSettings }) => {
    const messageBus = useMessageBus();
    const handleLinkClick = async () => {
        messageBus.publish("tracking.event", {
            payload: {
                event_name: listClickEvent,
            },
        });
    };
    const isArrowShown = [ListStyles.Arrow, ListStyles.Navigation, ListStyles.HorizontalArrows].includes(style);
    const anchorClasses = classNames(styles.listAnchor, {
        "ot-sdk-show-settings": enableCookieSettings,
    });
    return (_jsxs("li", { className: classNames(styles.listItem, styles[`listItem-${style}`]), "data-testid": "listItem", children: [style === ListStyles.BlueLinks && (_jsx(Button, { color: "tertiary", href: item?.path, className: classNames(anchorClasses, styles.blueLinkListItem), "data-testid": "listButton", target: item?.tabBehaviour === "sameTab" ? "_self" : "_blank", id: enableCookieSettings ? "ot-sdk-btn" : "", onClick: handleLinkClick, children: item?.title })), style !== ListStyles.BlueLinks && (_jsxs(LinkBehaviour, { href: item?.path, target: item?.tabBehaviour === "sameTab" ? "_self" : "_blank", id: enableCookieSettings ? "ot-sdk-btn" : "", className: anchorClasses, "data-testid": "listAnchor", onClick: handleLinkClick, children: [_jsx("span", { className: styles.listText, "data-testid": "listText", children: item?.title }), isArrowShown && (_jsx(Icon, { className: styles.listIcon, dataTestId: "listIcon", component: ArrowRight, width: "38px", height: "24px" }))] }))] }));
};
//# sourceMappingURL=ListItem.js.map